import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    /* Override bootstrap style */
    *, ::after, ::before {
        box-sizing: content-box;
    }
`;

export default GlobalStyle;
